module.exports = __webpack_public_path__ + "images/yunnan_banner01.jpg?53a877212808f23edf8357afacc8ecf1";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/yunnan_banner01.jpg
// module id = 211
// module chunks = 1